import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { SharePropertyService } from 'src/app/workspace/service/share-property.service';
import constants from 'src/constant.json';
import { UserState } from '../../state/user.state';
interface shareEvent {
  copyUrl: any;
  proceedAction?: any;
  shareUrl: string;
  shareStatus: boolean;
  enableSocialShare: boolean;
  enableCopyLink: boolean;
  dealData: any;
  propertyId: any;
  propertyUrl: any;
  propertyCity: any;
  propertyStreetAddress: any;
}

@Component({
  selector: 'app-link-share',
  templateUrl: './link-share.component.html',
  styleUrls: ['./link-share.component.scss'],
})
export class LinkShareComponent implements OnInit {
  @ViewChild('inviteUrlField') inviteUrlField: ElementRef;
  propertyImages: any;
  userName: string;
  userEmail: string;
  copyBtnText = 'copy';
  userDetailSub$;
  sharePropertyForm: FormGroup;
  shareUrl: string;
  sendData: any;
  enableButton: boolean = true;
  onDestroyNotifier$ = new Subject();
  propertyDetails: any;
  enableCopyLink: boolean = true;
  enableSocialShare: boolean = false;
  shareStatus: boolean;
  dealDetails: boolean;
  copyUrl: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: shareEvent,
    public dialogRef: MatDialogRef<LinkShareComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public appState: AppState,
    private userState: UserState,
    private sharePropertyService: SharePropertyService
  ) {}

  ngOnInit(): void {
    this.dealDetails = this.data.shareStatus;
    this.enableSocialShare = this.data.enableSocialShare;
    this.shareUrl = this.data.shareUrl;
    this.copyUrl = this.data.copyUrl;
    this.enableCopyLink = this.data.enableCopyLink;
    this.userDetailSub$ = this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.userName = res?.user_profile?.firstName;
      this.userEmail = res?.user_profile?.email;
    });

    this.sharePropertyForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
      email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
      recipientName: ['', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
      recipientEmail: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
    });
  }
  get sharePropertyFormControls() {
    return this.sharePropertyForm.controls;
  }
  close() {
    this.dialogRef.close(true);
  }

  sendUserDetails() {
    if (this.sharePropertyForm.invalid) {
      if (
        this.sharePropertyForm.controls.recipientName.status == 'INVALID' ||
        this.sharePropertyForm.controls.recipientEmail.status == 'INVALID'
      ) {
        return;
      } else if (!this.appState.authTokenValue?.idToken) {
        if (
          this.sharePropertyForm.controls.name.status == 'INVALID' ||
          this.sharePropertyForm.controls.email.status == 'INVALID'
        ) {
          return;
        }
      }
    }
    this.enableButton = false;
    this.propertyDetails = {
      recipientEmail: this.sharePropertyForm.value.recipientEmail.toLowerCase(),
      recipientName: this.sharePropertyForm.value.recipientName,
      senderName: this.appState.authTokenValue?.idToken ? this.userName : this.sharePropertyForm.value.name,
      senderEmail: this.appState.authTokenValue?.idToken
        ? this.userEmail.toLowerCase()
        : this.sharePropertyForm.value.email.toLowerCase(),
    };
    this.sharePropertyDetails(this.propertyDetails);
  }

  sharePropertyDetails(propertyDetails) {
    let data = {
      propertyId: this.data.propertyId,
      propertyUrl: this.data.propertyUrl,
      propertyStreetAddress: this.data.propertyStreetAddress,
      propertyCity: this.data.propertyCity,
      recipientName: propertyDetails.recipientName,
      recipientEmail: propertyDetails.recipientEmail,
      name: propertyDetails.senderName,
      email: propertyDetails.senderEmail,
    };
    if(this.data.shareStatus){
      this.dialogRef.close(data);
    } else {
      this.sharePropertyService
      .sharePropertyDetails(data)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe({
        next: (res: any) => {
          this.openSnackBar('Property shared successfully', 'snackbar-success');
          this.dialogRef.close();
        },
        error: (err) => {
          this.openSnackBar('Failed to share property', 'snackbar-error');
          this.enableButton = true;
        },
      });
    }

  }
  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
